import BaseRepository from '@/baseRepository/BaseRepository';
const tradeRequestMerchantNotificationsResource = `/api/v1/traderequestmerchantnotifications`;
const tradeResponseResource = `/api/v1/traderesponses`;
const tradeRequestResource = `/api/v1/traderequests`;
export default {
  getTradeResponseMembershipAndPrice(
    id,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.get(
      `${tradeResponseResource}/${id}/membership-and-price`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getTradeRequestMerchantNotificationsBySupplier(
    baseURL = {},
    headers = {},
    params = {},
    paramsSerializer
  ) {
    return BaseRepository.get(
      `${tradeRequestMerchantNotificationsResource}/by-supplier`,
      {
        baseURL,
        headers,
        params,
        paramsSerializer,
      }
    );
  },
  tradeRequestAbstractBySupplier(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${tradeResponseResource}/abstract/by-supplier`, {
      baseURL,
      headers,
      params,
    });
  },
  win(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${tradeResponseResource}/${id}/win`, body, {
      baseURL,
      headers,
      params,
    });
  },
  viewAssigned(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${tradeResponseResource}/${id}/view-assigned`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getTradeResponseByTradeRequsetOwner(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(
      `${tradeResponseResource}/by-trade-request-owner`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getTradeResponseById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${tradeResponseResource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  getTradeRequsetByIdForResponse(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${tradeRequestResource}/${id}/for-response`, {
      baseURL,
      headers,
      params,
    });
  },
  tradeRequestMerchantNotificationAccept(
    id,
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(
      `${tradeRequestMerchantNotificationsResource}/${id}/accept`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  tradeRequestMerchantNotificationReject(
    id,
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(
      `${tradeRequestMerchantNotificationsResource}/${id}/reject`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  saveResponse(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${tradeResponseResource}/draft`, body, {
      baseURL,
      headers,
      params,
    });
  },
  submitResponse(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${tradeResponseResource}/${id}/send`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  editResponse(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${tradeResponseResource}/${id}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  documnetsReviewedMerchantNotification(
    id,
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(
      `${tradeRequestMerchantNotificationsResource}/${id}/review-documents`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  deleteResponseItem(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${tradeResponseResource}/${id}/item/delete`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
};
